import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviDownload(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      color="currentColor"
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_Navi_Download_svg__Ebene_1"
      viewBox="0 0 22.2 24.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.2 16.36c-.55 0-1 .45-1 1v2.22c0 1.61-1.31 2.92-2.92 2.92H4.92C3.31 22.5 2 21.19 2 19.58v-2.22c0-.55-.45-1-1-1s-1 .45-1 1v2.22a4.93 4.93 0 0 0 4.92 4.92h12.36a4.93 4.93 0 0 0 4.92-4.92v-2.22c0-.55-.45-1-1-1Z" />
      <path d="M10.54 17.87c.19.2.45.32.73.32.28 0 .54-.12.73-.32l5.32-5.76a.996.996 0 0 0-.06-1.41.996.996 0 0 0-1.41.06l-3.59 3.88V1c0-.55-.45-1-1-1s-1 .45-1 1v13.65l-3.65-3.91a.997.997 0 1 0-1.46 1.36l5.38 5.76Z" />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviDownload
